// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ring-table__toolbar{background:inherit}.ring-table__toolbar-controls{display:block;position:relative;padding:16px 32px;min-height:24px;background:inherit;white-space:normal;white-space:initial}.ring-table__toolbar-controls.ring-table__toolbar-controls_fixed{z-index:2;z-index:calc(var(--ring-fixed-z-index) + 1);position:fixed;top:0;right:0;left:0}", ""]);
// Exports
module.exports = exports;
